import { useMemo } from "react";
import { useCampaign, useCampaignTypeById } from "features/campaigns/store";
import { type CampaignTypes, PRIZE_POP_CAMPAIGN_TYPE } from "features/campaigns";
import { normalizeCampaignAssets } from "features/campaigns/utils";
import { hexToRgba } from "utils/helpers";

export const useJoinInBtnStyles = (campaignId: string | null) => {
    const campaignType = useCampaignTypeById(campaignId ?? undefined);
    const campaign = useCampaign(campaignId ?? '', campaignType);

    return useMemo(() => {
        if (!campaignId) return;
        // Prize Pop Type uses the default styles in campaign-variables.module.css
        if (campaignType === PRIZE_POP_CAMPAIGN_TYPE) return {};
        if (!campaign?.resources) return undefined;
        
        const assets = normalizeCampaignAssets(campaign.resources, campaignType as CampaignTypes);
        if (!assets.colors.fill && !assets.colors.border) return undefined;
        
        return {
        '--campaign-join-in-glow': `0 0 4px 0 ${hexToRgba(assets.colors.border, 0.7)}, 0 1px 0 0 ${hexToRgba(assets.colors.border, 0.3)} inset`,
        '--campaign-join-in-fill-color': assets.colors.fill
        } as React.CSSProperties;
    }, [campaignId]);
}
